import React from 'react';
import SMConst from 'lib/SMConst';
import SMReservationChannelTypeResource from 'resources/SMReservationChannelTypeResource';
import SMRoomResource from 'resources/SMRoomResource';
import SMReservationResource from 'resources/SMReservationResource';
import SMUserResource from 'resources/SMUserResource';
import SMReservationEditView from 'components/dashboard/shared/SMReservationEditView';
import SMReservationEditViewSpace from 'components/dashboard/shared/SMReservationEditViewSpace';

class SMUReservationEditView extends SMReservationEditView {

  constructor(props) {
    super(props);

    var initialEndedDate = null;
    if (this.props.initialEndedDate) {
      initialEndedDate = new Date(this.props.initialEndedDate);
      initialEndedDate.setDate(initialEndedDate.getDate() + 1);
    }

    this.state = {
      user: this.props.user.attributes,
      owner: this.props.owner,
      spaceId: this.props.initialSpaceId,
      roomId: this.props.initialRoomId,
      room: null,
      plan: null,
      reservation: { status: SMConst.ReservationStatus.Confirmed },
      errors: [],
      isChangedPrice: false,
      statuses: [],
      channelTypes: [],
      startedDate: this.props.initialStartedDate ? new Date(this.props.initialStartedDate) : null,
      endedDate: initialEndedDate,
      startedHour: null,
      endedHour: null,
      stayCheckinAt: this.props.initialStayCheckinAt,
      stayCheckoutAt: this.props.initialStayCheckoutAt,
      saveButtonStatus: true,
    };

    this.handleClickSubmitButton = this.handleClickSubmitButton.bind(this);
    this.handleClickCancelButton = this.handleClickCancelButton.bind(this);
  }

  componentDidMount() {
    $(this.refs.form).startLoading();

    if (this.state.channelTypes.length == 0) {
      SMReservationChannelTypeResource.getReservationChannelTypes({}, function(channelTypes, error, xhr) {
        this.setState({ channelTypes: channelTypes });
      }.bind(this));
    }

    if (this.state.roomId) {
      SMRoomResource.getRoom(this.state.roomId, function(data, error, xhr) {
        this.setState(function(previousState, currentProps) {
          previousState.reservation.room = data;
          return {
            reservation: previousState.reservation,
            space: data.space,
            room: data,
            plan: data,
          };
        });
      }.bind(this));
    }

    SMUserResource.getReservation(this.state.user.username, this.props.reservationId, function(reservation, error, xhr) {
      // APIから時刻を取得
      // JSTの時間をISO表記で送られるため、Date型に直すと+9時間進む
      var startedAt = reservation.started_at ? new Date(reservation.started_at) : null;
      var endedAt = reservation.ended_at ? new Date(reservation.ended_at) : null;
      var stayCheckinAt = reservation.stay_checkin_at ? new Date(reservation.stay_checkin_at) : null;
      var stayCheckoutAt = reservation.stay_checkout_at ? new Date(reservation.stay_checkout_at) : null;

      // +9時間進んだ時刻を戻す
      var changedStartedAt = startedAt ? new Date(startedAt.getTime() - reservation.room.space.utc_offset * 1000) : null;
      var changedEndedAt = endedAt ? new Date(endedAt.getTime() - reservation.room.space.utc_offset * 1000) : null;
      var changedStayCheckinAt = stayCheckinAt ? new Date(stayCheckinAt.getTime() - reservation.room.space.utc_offset * 1000) : null;
      var changedStayCheckoutAt = stayCheckoutAt ? new Date(stayCheckoutAt.getTime() - reservation.room.space.utc_offset * 1000) : null;

      // 開始日時の日と時刻を分離
      var startedDate = changedStartedAt ? this.beginningOfDate(changedStartedAt) : null;
      var startedHour = changedStartedAt ? changedStartedAt.getHours() : null;

      // 終了日時の日と時刻を分離
      var endedDate = changedEndedAt ? this.beginningOfDate(changedEndedAt) : null;
      var endedHour = changedEndedAt ? changedEndedAt.getHours() : null;

      if (this.props.method == SMConst.ReservationMethod.Inquiry && endedDate) endedDate.setDate(endedDate.getDate() + 1);

      var plan = reservation.plan_id == 0 ? reservation.room : reservation.plan;
      if (plan && (plan.price_calc_type == SMConst.PriceCalcType.PerPerson || plan.rent_type == SMConst.RentType.Stay)) {
        if (!reservation.number_of_guests) reservation.number_of_guests = 1;
      } else {
        if (!reservation.capacity) reservation.capacity = 10;
      }

      this.setState({
        reservation: reservation,
        spaceId: reservation.room.space.username,
        roomId: reservation.room.uid,
        space: reservation.room.space,
        room: reservation.room,
        plan: reservation.plan_id == 0 ? reservation.room : reservation.plan,
        isChangedPrice: !!(reservation.billing && reservation.billing.total_changed_amount != null),
        startedDate: startedDate,
        startedHour: startedHour,
        endedDate: endedDate,
        endedHour: endedHour,
        stayCheckinAt: changedStayCheckinAt,
        stayCheckoutAt: changedStayCheckoutAt,
      });

      if (reservation.method == SMConst.ReservationMethod.Inquiry && reservation.started_at && reservation.ended_at) {
        setTimeout(function() {
          this.updateResource([], true);
        }.bind(this), 500);
      } else {
        $(this.refs.form).stopLoading();
      }
    }.bind(this));
  }

  updateResource(arrayValues, dryrun, changePoint) {
    var formData = new FormData();
    var queries = {};
    var responseHandler = function(reservation, error, xhr) {
      if (xhr.status == 200 || xhr.status == 201) {
        if (dryrun) {
          if (!dryrun) $(this.refs.form).stopLoading();

          if (reservation.plan_id != this.state.reservation.plan_id) {
            reservation.billing.total_amount_text = null;
          }

          this.setState({
            reservation: reservation,
            errors: [],
          });
          $(this.refs.form).stopLoading();
        } else {
          if (xhr.responseJSON.unapproved_reservation != null) window.alert(I18n.t("dashboard.text_000052"));
          location.href = Routes.dashboard_reservation_path(this.state.reservation.uid);
        }
      } else if (xhr.status == 400) {
        $(this.refs.form).stopLoading();
        var errors = xhr.responseJSON.errors;
        if (dryrun) {
          errors = [];
          for (i = 0; i < xhr.responseJSON.errors.length; i++) {
            if (xhr.responseJSON.errors[i].field.search(/^reservation_user/) == -1) {
              errors.push(xhr.responseJSON.errors[i]);
            }
          }
        }
        reservation = JSON.parse(xhr.responseText).resource;
        errors = this.uniqueErrorMessage(errors);

        this.setState({
          reservation: reservation,
          errors: errors
        });
      } else {
        $(this.refs.form).stopLoading();
      }

      this.setState({
        saveButtonStatus: true
      });
    }.bind(this);

    var names = [];
    for (var i = 0; i < arrayValues.length; i++) {
      var value = arrayValues[i];
      formData.append(value[0], value[1]);
      names.push(value[0]);
    }

    if (dryrun) queries.dryrun = dryrun;

    // 更新系以外のパラメータを設定
    if (names.indexOf('user_id') == -1) formData.append('user_id', this.state.user.id);
    this.setOtherFormData(names, formData, changePoint);

    if (this.state.reservation.id) {
      SMUserResource.updateReservation(
        this.state.user.username,
        this.state.reservation.id,
        formData,
        queries,
        responseHandler
      );
    } else {
      SMReservationResource.postReservation(formData, queries, responseHandler);
    }

    if (!dryrun) $(this.refs.form).startLoading();
  }

  // event observer
  handleClickCancelButton(e) {
    location.href = Routes.dashboard_reservation_path(this.state.reservation.uid);
  }

  handleClickSubmitButton(e) {
    e.preventDefault();
    this.trackPageEvent('od submit edit_reservation_from_user');

    this.setState({
      saveButtonStatus: false
    });
    this.updateResource([], false);
  }

  renderReservation() {
    return (
      <div>
        <h3 className="dashboard-title2 mb20">予約内容</h3>
        <table ref='reservationTable' className="dashboard-form-table mb50">
          <tbody>
          {this.renderPlans()}
          {this.isStayReservation() ? this.renderStaySchedules() : this.renderSchedules()}
          {this.isStayReservation() ? this.renderCheckInTime() : null}
          {this.canDisplayNumberOfGuests() ? this.renderHeadCount() : this.renderCapacity()}
          {this.renderOptionItems()}
          {this.renderOptionFoods()}
          {this.renderStatus()}
          {this.renderPrice(false)}
          {this.renderEventType()}
          {this.renderUseType()}
          </tbody>
        </table>
      </div>
    );
  }

  renderCustomer() {
    return (
      <div>
        <h3 className="dashboard-title2 mb20">お客様情報</h3>
        <table className="dashboard-form-table mb80">
          <tbody>
          {this.renderTel()}
          {this.renderName()}
          {this.renderCorpName()}
          {this.renderEmail()}
          {this.renderGuestName()}
          {this.renderPaymentPeriod(false)}
          {this.renderChannelType()}
          </tbody>
        </table>
      </div>
    );
  }

  renderCalendarLink() {
    return (
      <p className="mt10">
        <a href={Routes.space_room_reservations_path(this.state.room.space.username, this.state.room.uid)}
           target="_blank" className="link-hover-border">空き状況の確認</a>
      </p>
    );
  }

  render() {
    var label, submitLabel;

    switch (this.state.reservation.method) {
      case SMConst.ReservationMethod.Inquiry:
        label = I18n.t("dashboard.label_000147");
        submitLabel = I18n.t("dashboard.label_000148");
        break;
      case SMConst.ReservationMethod.Reservation:
      default:
        if (this.props.action == 'edit') {
          label = I18n.t("dashboard.label_000149");
          submitLabel = I18n.t("dashboard.label_000151");
        } else {
          label = I18n.t("dashboard.label_000150");
          submitLabel = I18n.t("dashboard.label_000120");
        }
        break;
    }

    return (
      <div className="dashboard-container clearfix mb30">
        <div className="dashboard-maincol" ref="formContent">
          <h2 className="dashboard-title mb30">{label}</h2>

          <form ref='form'>
            <input type='hidden' name='user_id' value={this.state.user.username} />

            {this.renderReservation()}
            {this.renderCustomer()}

            <div className="js-dashboard-main-table-footer maincol-buttonarea dashboard-maincol__right-inner-100pc">
              <input data-href={Routes.dashboard_reservations_path}
                     className="button-gray maincol-buttonarea__button"
                     type="button"
                     value={I18n.t("dashboard.label_000152")} onClick={this.handleClickCancelButton} />
              <input data-href={Routes.dashboard_reservations_path}
                     className={this.canSubmitButton() ? "button-green maincol-buttonarea__button" : "button-disabled maincol-buttonarea__button"}
                     disabled={!this.canSubmitButton()}
                     type="submit"
                     value={submitLabel}
                     onClick={this.handleClickSubmitButton} />
            </div>
          </form>
        </div>
      </div>
    );
  }
}
export default SMUReservationEditView;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/reservations/SMUReservationEditView.jsx